import { useSelector } from 'react-redux';
export default function useItem(firstLevel, secondLevel, session) {
  const item = useSelector(state => state[firstLevel][secondLevel]);
  if (item) {
    return item;
  }
  return null;
};